<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">User Management</span>
        <v-spacer></v-spacer>
        <v-btn v-if="$store.getters.isPlatformAdmin" color="success" class="mr-2" @click="seedUsers"
          >Seed Users</v-btn
        >
        <v-btn color="primary" @click="openCreateDialog">Add User</v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="search"
          label="Search users"
          clearable
          class="mb-2"
        />
        <v-data-table
          :headers="headers"
          :items="users"
          :search="search"
          item-key="id"
          dense
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon small @click="editUser(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small @click="deleteUser(item)">
              <v-icon small color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogVisible" max-width="400px">
      <v-card>
        <v-card-title>
          <span v-if="dialogMode === 'create'">Add User</span>
          <span v-else>Edit User</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="dialogUser.name" label="Name" required />
          <v-text-field v-model="dialogUser.email" label="Email" required />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogVisible = false">Cancel</v-btn>
          <v-btn color="primary" @click="submitDialog">
            {{ dialogMode === "create" ? "Create" : "Update" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { apiClient } from "@shared/services/api";

export default {
  name: "AdminUsers",
  data() {
    return {
      users: [],
      search: "",
      dialogVisible: false,
      dialogMode: "create",
      dialogUser: { name: "", email: "" },
      headers: [
        { text: "ID", value: "id" },
        { text: "Email", value: "email" },
        { text: "Name", value: "name" },
        { text: "Actions", value: "actions", sortable: false }
      ]
    };
  },
  computed: {},
  methods: {
    openCreateDialog() {
      this.dialogMode = "create";
      this.dialogUser = { name: "", email: "" };
      this.dialogVisible = true;
    },
    editUser(user) {
      this.dialogMode = "edit";
      this.dialogUser = { ...user };
      this.dialogVisible = true;
    },
    submitDialog() {
      var self = this;
      if (this.dialogMode === "create") {
        apiClient
          .post("/users/", {
            name: this.dialogUser.name,
            email: this.dialogUser.email
          })
          .then(function () {
            self.dialogVisible = false;
            self.fetchUsers();
          })
          .catch(function (error) {
            console.error("Create user error:", error);
            self.$emit("error", "Failed to create user");
          });
      } else if (this.dialogMode === "edit") {
        apiClient
          .patch("/users/" + this.dialogUser.id, {
            name: this.dialogUser.name,
            email: this.dialogUser.email
          })
          .then(function () {
            self.dialogVisible = false;
            self.fetchUsers();
          })
          .catch(function (error) {
            console.error("Update user error:", error);
            self.$emit("error", "Failed to update user");
          });
      }
    },
    deleteUser(user) {
      var self = this;
      if (!confirm("Are you sure you want to delete this user?")) return;
      apiClient
        .delete("/users/" + user.id)
        .then(function () {
          self.fetchUsers();
        })
        .catch(function (error) {
          console.error("Delete user error:", error);
          self.$emit("error", "Failed to delete user");
        });
    },
    fetchUsers() {
      var self = this;
      apiClient
        .get("/admin/users/")
        .then(function (res) {
          console.log("Users data:", res.data);
          if (Array.isArray(res.data)) {
            self.users = res.data;
          } else {
            console.error("Expected array of users but got:", res.data);
            self.users = [];
          }
        })
        .catch(function (error) {
          console.error("Fetch users error:", error);
          self.$emit("error", "Failed to fetch users");
          self.users = [];
        });
    },
    seedUsers() {
      var self = this;
      apiClient
        .post("/admin/seed-users/")
        .then(function (res) {
          self.fetchUsers();
          self.$emit(
            "success",
            (res.data && res.data.message) || "Users seeded successfully"
          );
        })
        .catch(function (error) {
          console.error("Seed users error:", error);
          self.$emit("error", "Failed to seed users");
        });
    }
  },
  mounted() {
    this.fetchUsers();
  }
};
</script>
